export const color = {
  dark: '#575962',
  darker: '#3f4047',
}
